import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface SectionState {
  activeSection: string;
  isPortalLoaded: boolean;
  isLoaded: {
    recent: boolean;
    favoriteDesign: boolean;
    favoriteProduct: boolean;
    design: boolean;
    order: boolean;
    invoice: boolean;
    account: boolean;
  };
}

const initialState: SectionState = {
  activeSection: '',
  isPortalLoaded: false,
  isLoaded: {
    recent: false,
    favoriteDesign: false,
    favoriteProduct: false,
    design: false,
    order: false,
    invoice: false,
    account: false,
  },
};

const sectionSlice = createSlice({
  name: 'section',
  initialState,
  reducers: {
    setActiveSection: (state, action: PayloadAction<string>) => {
      state.activeSection = action.payload;
    },
    setSectionLoaded: (state, action: PayloadAction<keyof SectionState['isLoaded']>) => {
      const property = action.payload;
      state.isLoaded[property] = true;

      /* Check if all properties within isLoaded are true */
      const allPropertiesLoaded = Object.values(state.isLoaded).every((value) => value);

      /* If all properties are true, set isPortalLoaded to true */
      if (allPropertiesLoaded) {
        state.isPortalLoaded = true;
      }
    },
  },
});

export const { setActiveSection, setSectionLoaded } = sectionSlice.actions;

export default sectionSlice.reducer;
